import React from 'react'
import PropTypes from 'prop-types'
import Event from '@app/models/event'
import StateLabel from './'

const Friendship = ({ event }) => {
  return (
    <div className="friendship">
      <div className="friendship__state-label">
        <StateLabel event={event} />
      </div>
    </div>
  )
}

Friendship.propTypes = {
  event: PropTypes.instanceOf(Event).isRequired
}

export default Friendship
